interface ActionTypes {
  SET_CURRENT_TEAM: string;
  DISABLE_TEAM_PICKER: string;
  RESET_CUSTOM_TEAM_BASE_MAP: string;
  SET_CUSTOM_TEAM_BASE_MAP_CREDENTIAL: string;
  GET_CUSTOM_TEAM_BASE_MAP_TOKEN_START: string;
  GET_CUSTOM_TEAM_BASE_MAP_TOKEN_SUCCESS: string;
  GET_CUSTOM_TEAM_BASE_MAP_TOKEN_FAILURE: string;
  GET_TEAMS_LIST_START: string;
  GET_TEAMS_LIST_SUCCESS: string;
  GET_TEAMS_LIST_FAILURE: string;
  SET_TEAM_BOUNDARY_TOGGLE: string;
}

export enum TEAM_NAME {
  PRIVATE = 'Private team'
}

export interface TeamQueryParams {
  others?: boolean;
  sorting: string;
  all?: boolean;
}

export interface CustomTeamTokenParams {
  key: string;
  secret: string;
}

export const TeamActionTypes: ActionTypes = {
  SET_CURRENT_TEAM: '@@SET_CURRENT_TEAM',
  DISABLE_TEAM_PICKER: '@@DISABLE_TEAM_PICKER',
  RESET_CUSTOM_TEAM_BASE_MAP: '@@RESET_CUSTOM_TEAM_BASE_MAP',
  SET_CUSTOM_TEAM_BASE_MAP_CREDENTIAL: '@@SET_CUSTOM_TEAM_BASE_MAP_CREDENTIAL',
  GET_CUSTOM_TEAM_BASE_MAP_TOKEN_START:
    '@@GET_CUSTOM_TEAM_BASE_MAP_TOKEN_START',
  GET_CUSTOM_TEAM_BASE_MAP_TOKEN_SUCCESS:
    '@@GET_CUSTOM_TEAM_BASE_MAP_TOKEN_SUCCESS',
  GET_CUSTOM_TEAM_BASE_MAP_TOKEN_FAILURE:
    '@@GET_CUSTOM_TEAM_BASE_MAP_TOKEN_FAILURE',
  GET_TEAMS_LIST_START: '@@GET_TEAMS_LIST_START',
  GET_TEAMS_LIST_SUCCESS: '@@GET_TEAMS_LIST_SUCCESS',
  GET_TEAMS_LIST_FAILURE: '@@GET_TEAMS_LIST_FAILURE',
  SET_TEAM_BOUNDARY_TOGGLE: '@@SET_TEAM_BOUNDARY_TOGGLE'
};

export interface TeamState {
  currentTeamId?: number;
  currentTeamName?: string;
  currentTeamBaseMapType?: string;
  currentTeamBaseMapId?: string;
  currentTeamBaseMapToken?:
    | string
    | {
        access_token: string;
        expires_in: number;
      };
  customBaseMapKey?: string;
  customBaseMapSecret?: string;
  currentTeamShape?: GeoJSON.Polygon;
  teamPickerDisabled?: boolean;
  teamsList?: any[];
  loadingTeamsList?: boolean;
  toggleTeamBoundary?: boolean;
  currentTeamDefaultValues?: any;
}
